export default {
  customized: {
    label: '定制图片&视频',
    filter: {
      network: {
        massive: '巨量引擎（今日头条，穿山甲，抖音）',
        engine: '今日头条',
        tencent: '广点通',
        baidu: '百度信息流',
        kuaishou: '快手',
        wifi: 'WiFi万能钥匙',
        fan: '粉丝通',
        wechat: '微信',
        mostright: '最右',
        other: '其他',
      },
    },
    describe:
      '我们提供高质量的创意定制与多样化的营销策划服务，满足您不同的营销目标和场景。',
    table: {
      operation: {
        applytips: '推送产品',
      },
    },
  },
}
